









































import { Vue, Component, Prop } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    FormFieldsContainer,
  },
})
export default class opcionesCS extends Vue {
  @Prop({ default: null }) model_tipo_cambio: any;

  cambio_tipo(event: any, value: string) {
    if (event) {
      this.$emit('input', value);
    }
  }
} //end class
